<style>
.select__container {
  margin-top: 10px;
}
.select__container--el {
  display: flex;
  justify-content: space-between;
}
#printHydrantCardModal .v--modal-box.v--modal {
  min-height: 170px !important;
  min-width: 200px !important;
}
.modal__content {
  padding-top: 5px;
}
#printHydrantCardModal .v-input--selection-controls {
  margin-top: 5px;
}
#printHydrantCardModal .v-input--selection-controls.v-input .v-label {
  font-size: 12px;
}
#printHydrantCardModal *:not(.modal__header__btn > .v-icon) {
  font-size: 12px;
}
</style>

<template>
  <Modal
    modalName="printHydrantCardModal"
    title="Wydrukuj kartę hydrantu"
    :buttons="['print']"
    @print="print"
    :module="module"
  >
    <v-form
      v-model="valid"
      ref="form"
    >
      <v-layout>
        <v-flex xs5>
          <v-text-field
            height="16"
            label="ID hydrantu"
            type="text"
            readonly
            v-model="hydrantID"
          />
        </v-flex>
        <v-spacer />
        <v-flex xs5>
          <v-select
            :items="hydrantInspections"
            label="Wybierz przegląd do wydruku"
            item-text="id"
            :height="16"
            v-model="inspectionID"
            :rules="inspectionRules"
          >
          </v-select>
        </v-flex>
      </v-layout>

    </v-form>
  </Modal>
</template>

<script>
import Modal from "../../../../shared/Modal";

export default {
  components: {
    Modal
  },
  data: () => ({
    hydrantID: "",
    hydrantInspections: [],
    valid: false,
    inspectionID: undefined,
    module: "inspections",
    inspectionRules: [v => !!v || "Wybierz przegląd"]
  }),
  methods: {
    setData(data) {
      this.hydrantID = data;
      this.$store.dispatch('getInspectionCards').then(r => {
        this.hydrantInspections = r.inspections.filter(el => el.hydrant == this.hydrantID);
      });
    },
    print() {
      if(this.$refs.form.validate()) {
        this.$root.$emit("printReport", ['hydrantCard', this.hydrantID, this.inspectionID])
      }
    }
  },
  mounted() {
    this.$root.$on("printHydrantCard", this.setData)
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/hydrants/modals/hydrants/PrintHydrantCard.vue